import { BasketItem } from '@aboutyou/backbone';
import { sum } from 'modules/math';
import {
  DAILY_DEAL_PRODUCT_LABEL,
  FREE_PRODUCT_LABEL,
} from 'commerce/scayle/constants';
import { BasketResponse } from 'commerce/scayle/user-interaction/types';
import { Product } from 'commerce/scayle/utils/adapter';

// 1. If there is one product with minimum_order_value minimum_order_value should be displayed in info text
// 2. If there are two or more products with attribute "label: daily_deal", values of attribute: minimum_order_value_summable should be summarized and displayed in info text
// 3. If two or more products with attribute "label: kostenlos" minimum_order_value of the first product should be displayed in info text
// 4. If there is one or more products with attribute "label: daily_deal"
// AND
// one or more products with attribute "label: kostenlos"
// values of attribute: minimum_order_value_summable ONLY for Daily Deal products should be summarized and displayed in info text
export const getMinimumOrderValue = (cart: BasketResponse): number => {
  if (!cart) {
    return 0;
  }

  const initProducts = cart.items.map((item) =>
    Product.createCartProduct(item).toJSON(),
  );

  const productsWithMinOrderValue = initProducts.filter(
    (product) => product.minimumOrderValue || product.minimumOrderValueSummable,
  );
  const dailyProducts = productsWithMinOrderValue.filter(
    (product) => product.label === DAILY_DEAL_PRODUCT_LABEL,
  );

  const freeProducts = productsWithMinOrderValue.filter(
    (product) => product.label === FREE_PRODUCT_LABEL,
  );

  const isSummable =
    (!!dailyProducts.length && !!freeProducts.length) ||
    dailyProducts.length >= 2;

  if (isSummable) {
    return dailyProducts.reduce(
      (acc, item) => sum(acc, item?.minimumOrderValueSummable || 0),
      0,
    );
  }

  return productsWithMinOrderValue?.[0]?.minimumOrderValue || 0;
};

export const hasFreeProducts = (cart: BasketResponse): boolean => {
  return cart?.items
    ?.map((item) => {
      const data = Product.createProduct(item.product);

      return data.label;
    })
    .includes(FREE_PRODUCT_LABEL);
};

export const hasDailyDealProducts = (cart: BasketResponse): boolean => {
  return cart?.items
    ?.map((item) => {
      const data = Product.createProduct(item.product);

      return data.label;
    })
    .includes(DAILY_DEAL_PRODUCT_LABEL);
};

export const hasOnlyProductsFromCategory = (
  categoryName: string,
  items?: BasketItem[],
) => {
  return (
    items?.every((item) =>
      item.product.categories?.some((category) =>
        category.some(
          (subCategory) => subCategory.categoryName === categoryName,
        ),
      ),
    ) || false
  );
};
